import { walletShort, vaultIdShort } from "../../components/common/dataShort";

export default function FormattedChartData(v) {
  let wallet =
    v.titles.Wallet.substr(0, 4) +
    "..." +
    v.titles.Wallet.substr(v.titles.Wallet.length - 4);
  const colors = ["#5470c6", "#91cc75", "#85c1e9"];

  const textColor = v.titles.isLatestBalRwd0 ? "#990000" : "#000000";

  return {
    wallet: walletShort(v.titles.Wallet),
    walletLong: v.titles.Wallet,
    blockchain: v.titles.Blockchain,
    platform: v.titles.Platform,
    data2: {
      id: v.titles.assetId,
      title: {
        text:
          vaultIdShort(v.titles.assetId) +
          ". " +
          v.titles.Vault +
          " @ " +
          v.titles.Platform +
          (v.titles.Uses ? " (" + v.titles.Uses + ")" : ""),
        textStyle: { fontSize: 14, color: textColor },
        subtext: wallet + " @ " + v.titles.Blockchain,
      },
      grid: {
        top: "30%",
        left: "20%",
        right: "20%",
      },
      color: colors,
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
        },
      },
      xAxis: {
        type: "category",
        boundaryGap: true,
        // prettier-ignore
        data: v.dtA,
      },
      yAxis: [
        {
          type: "value",
          name: "Balance",
          position: "left",
          axisLabel: {
            formatter: "{value}",
          },
          axisPointer: {
            snap: true,
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: colors[0],
            },
          },
          scale: true,
        },
        {
          type: "value",
          name: "APR",
          position: "right",
          axisLabel: {
            formatter: "{value}%",
          },
          axisPointer: {
            snap: true,
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#81bc65",
            },
          },
          scale: true,
        },
      ],
      series: [
        {
          name: v.titles.Vault,
          type: "line",
          smooth: true,
          // prettier-ignore
          data: v.balA,
          areaStyle: { opacity: 0.05 },
        },
        {
          name: "APR",
          type: "bar",
          barMaxWidth: "50%",
          smooth: true,
          // prettier-ignore
          data: v.aprA,
          yAxisIndex: 1,
        },
      ],
      dna: {
        auto: v.titles.auto,
        closed: v.titles.isLatestBalRwd0,
        sortNo: v.titles.sortNo,
        daysBetween: v.titles.daysBetween,
        balanceApr: v.titles.balanceApr,
        totalApr: v.titles.totalApr,
      },
    },

    data3: {
      id: v.titles.assetId,
      title: {
        text:
          vaultIdShort(v.titles.assetId) +
          ". " +
          v.titles.Vault +
          " @ " +
          v.titles.Platform +
          (v.titles.Uses ? " (" + v.titles.Uses + ")" : ""),
        textStyle: { fontSize: 14, color: textColor },
        subtext: wallet + " @ " + v.titles.Blockchain,
      },
      grid: {
        top: "30%",
        left: "20%",
        right: "20%",
      },
      color: colors,
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
        },
      },
      xAxis: {
        type: "category",
        boundaryGap: true,
        // prettier-ignore
        data: v.dtA,
      },
      yAxis: [
        {
          type: "value",
          name: "Balance",
          position: "left",
          axisLabel: {
            formatter: "{value}",
          },
          alignTicks: true,
          axisPointer: {
            snap: true,
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: colors[0],
            },
          },
          scale: true,
        },
        {
          type: "value",
          name: "APR",
          position: "right",
          axisLabel: {
            formatter: "{value}%",
          },
          axisPointer: {
            snap: true,
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#81bc65",
            },
          },
          scale: true,
        },
        {
          type: "value",
          name: "Bal+Rwds",
          position: "left",
          axisLabel: {
            formatter: "{value}$",
          },
          alignTicks: true,
          offset: 60,
          axisLine: {
            show: false,
            lineStyle: {
              color: colors[2],
            },
          },
          scale: true,
        },
      ],
      series: [
        {
          name: v.titles.Vault,
          type: "line",
          smooth: true,
          // prettier-ignore
          data: v.balA,
          areaStyle: { opacity: 0.05 },
        },
        {
          name: "APR",
          type: "bar",
          barMaxWidth: "40%",
          smooth: true,
          // prettier-ignore
          data: v.aprA,
          yAxisIndex: 1,
        },
        {
          name: "Total $",
          type: "line",
          smooth: true,
          // prettier-ignore
          data: v.totalUsdA,
          yAxisIndex: 2,
        },
      ],
      dna: {
        auto: v.titles.auto,
        closed: v.titles.isLatestBalRwd0,
        sortNo: v.titles.sortNo,
        daysBetween: v.titles.daysBetween,
        balanceApr: v.titles.balanceApr,
        totalApr: v.titles.totalApr,
      },
    },
  };
}
